import React from 'react';

import { useTranslation } from 'react-i18next';
import { Navigate, useNavigate, useLocation } from 'react-router-dom';

import { WAuthLayout, WButton } from '@wareclouds/wareclouds-ui';

import logo from '../../../../assets/img/logo.svg';

export default function PasswordRecoverySuccessPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;

  const { t } = useTranslation(['auth']);

  if (!state?.emailSent) {
    return <Navigate to="/login" replace />;
  }

  return (
    <WAuthLayout
      title={t('password_request.success.title', { ns: 'auth' })}
      subtitle={t('password_request.success.subtitle', { ns: 'auth' })}
      logo={logo}
    >
      <WButton
        onClick={() => navigate('/login')}
        variant="contained"
        fullWidth
        label={t('button.return_back_to_login', { ns: 'auth' })}
      />
    </WAuthLayout>
  );
}
